/* eslint-disable react/jsx-handler-names */
'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React from 'react';
import {IonKeyboardAttach} from '../../../../_libs/reactionic/src/components/ionKeyboardAttach';
import {StatusOverlay} from '../../../../core-components/loading-icon/components/StatusOverlay';
import {FORM_MODE} from '../../../../forms/enums/FormMode';
import {FormFieldResponse} from '../FormFieldResponse';


const defaultStyle = {};

function BaseFormResponseView(props) {
  const internalModel = props.internalModel || {};
  const validationMessages = props.validationMessages || {};
  const {
    useKeyboardPadding,
    keyboardHeight,
  } = props;

  try {
    return (
      <div
        className={classNames("FormResponse", props.className)}
        style={getStyle(useKeyboardPadding, keyboardHeight)}
      >
        <div className="FormResponse__wrapper">
          {props.fields ? (
            props.fields.map(field => (
              <FormFieldResponse
                key={field.id}
                field={field}
                value={internalModel[field.id]}
                isEditing={props.isEditing}
                isSaving={props.isSaving}
                validationMessages={validationMessages[field.id]}

                onChange={props.onChange}
              />
            ))
          ) : null}
        </div>
        <StatusOverlay mode={FORM_MODE.toViewMode(props.mode)} />
      </div>
    );
  } catch (e) {
    console.error(e);
    return `Error occurred: ${e ? e.message : '(unknown)'}`;
  }
}

BaseFormResponseView.propTypes = {
  className: T.string,
  useKeyboardPadding: T.bool,
  keyboardHeight: T.number,
};

BaseFormResponseView.defaultProps = {
  className: '',
  keyboardHeight: 0,
};

export const FormResponseView = IonKeyboardAttach(BaseFormResponseView);

function getStyle(useKeyboardPadding, keyboardHeight) {
  return {
    style: keyboardHeight === 0 || !useKeyboardPadding
      ? defaultStyle
      : {marginBottom: keyboardHeight + 'px'},
  };
}



// WEBPACK FOOTER //
// ./src/js/form-builder/components/response/FormResponse/FormResponseView.js